import { createFileRoute } from '@tanstack/react-router';
import { productPhotoSlot } from '@/app/commercial/slots';
import { ErrorState, Page, Skeleton } from '@/core/ui';
import { ProductEditor, productQuery, useProduct } from '@/modules/products/public';
import { RequirePermission, usePermissions } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/produtos/$productId')({
  loader: ({ context, params }) => context.queryClient.prefetchQuery(productQuery(params.productId)),
  component: function ProductRoute() {
    const { productId } = Route.useParams();
    const navigate = Route.useNavigate();
    const { can } = usePermissions();
    const product = useProduct(productId);
    return (
      <RequirePermission anyOf={['produtos.ver']}>
        {product.isPending ? (
          <Page>
            <Skeleton className="h-96 rounded-2xl" />
          </Page>
        ) : product.isError ? (
          <Page>
            <ErrorState error={product.error} onRetry={() => void product.refetch()} />
          </Page>
        ) : (
          <ProductEditor
            // Remonta ao trocar de produto.
            key={product.data.id}
            product={product.data}
            canEdit={can('produtos.editar')}
            imageSlot={productPhotoSlot}
            onBack={() => navigate({ to: '/produtos' })}
            onSaved={() => undefined}
            onDeleted={() => navigate({ to: '/produtos' })}
          />
        )}
      </RequirePermission>
    );
  },
});
